import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../../data/mock';
import {
  Facebook,
  Instagram,
  Twitter,
  MessageCircle,
  Mail,
  Phone,
  MapPin,
  ExternalLink
} from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <span className="text-2xl font-bold text-white tracking-tight">UPIM</span>
            </div>
            <p className="text-gray-400 text-sm mb-4 leading-relaxed">
              Unión de Profesionales Inmobiliarios de México A.C. Tu plataforma exclusiva como socio UPIM con CRM e inteligencia artificial.
            </p>
            <div className="flex space-x-3">
              <a
                href={companyInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="h-10 w-10 rounded-full bg-gray-800 hover:bg-gray-700 flex items-center justify-center transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href={companyInfo.social.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="h-10 w-10 rounded-full bg-gray-800 hover:bg-gray-700 flex items-center justify-center transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="h-5 w-5" />
              </a>
              <a
                href={companyInfo.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="h-10 w-10 rounded-full bg-gray-800 hover:bg-gray-700 flex items-center justify-center transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href={companyInfo.social.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="h-10 w-10 rounded-full bg-gray-800 hover:bg-gray-700 flex items-center justify-center transition-colors"
                aria-label="WhatsApp"
              >
                <MessageCircle className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/nosotros" className="text-gray-400 hover:text-white transition-colors text-sm">
                  ¿Quiénes Somos?
                </Link>
              </li>
              <li>
                <Link to="/beneficios" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Beneficios
                </Link>
              </li>
              <li>
                <Link to="/afiliacion" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Afíliate
                </Link>
              </li>
              <li>
                <Link to="/calendario" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Calendario
                </Link>
              </li>
              <li>
                <Link to="/recursos" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Recursos
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Servicios</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/proveedores" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Proveedores Certificados
                </Link>
              </li>
              <li>
                <Link to="/academia" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Academia UPIM
                </Link>
              </li>
              <li>
                <a
                  href="https://upim.easybroker.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors text-sm flex items-center"
                >
                  Bolsa Inmobiliaria (BIC)
                  <ExternalLink className="h-3 w-3 ml-1" />
                </a>
              </li>
              <li>
                <Link to="/beneficios" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Avalúos con IA
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-gray-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">{companyInfo.address}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-gray-500 flex-shrink-0" />
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-gray-500 flex-shrink-0" />
                <a
                  href={`tel:${companyInfo.phone}`}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  55 7116 4745
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <MessageCircle className="h-5 w-5 text-gray-500 flex-shrink-0" />
                <a
                  href={companyInfo.social.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  WhatsApp: 55 7116 4745
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {currentYear} {companyInfo.name}. Todos los derechos reservados.
            </p>
            <div className="flex space-x-6">
              <Link to="/aviso-privacidad" className="text-gray-500 hover:text-white text-sm transition-colors">
                Aviso de Privacidad
              </Link>
              <Link to="/terminos" className="text-gray-500 hover:text-white text-sm transition-colors">
                Términos y Condiciones
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
